import { adTargetingParameters } from './adTargetingParameterReducer';
import { airQuality } from './airQualityReducer';
import { alerts } from './alertsReducer';
import { almanac } from './almanacReducer';
import { backgroundImage } from './backgroundImageReducer';
import { contentManagementTemplate } from './contentManagementReducer';
import { currentStationObs } from './currentStationObsReducer';
import { averageObs } from './averageObsReducer';
import { historicalObs } from './historicalObsReducer';
import { feedback } from './feedbackReducer';
import { fire } from './fireReducer';
import { forecast } from './forecastReducer';
import { forecastV5 } from './forecastReducerV5';
import { hurricaneOutlookBulletin } from './Hurricane/Outlook/Bulletin/hurricaneOutlookBulletinReducer';
import { hurricaneOutlookSummary } from './Hurricane/Outlook/Summary/hurricaneOutlookSummaryReducer';
import { hurricane } from './hurricaneReducer';
import { icon } from './iconReducer';
import { lightning } from './lightningReducer';
import { locationDetails } from './locationDetailsReducer';
import { locationSearch } from './locationSearchReducer';
import { userSettings } from './entityManagementSettingReducer';
import { nowContent } from './nowContentReducer';
import { pollen } from './pollenReducer';
import { precipitation } from './precipitationReducer';
import { storedLocation } from './storedLocationReducer';
import { stories } from './storiesReducer';
import { trafficCam } from './trafficCamReducer';
import { uv } from './uvReducer';
import { video } from './videoReducer';
import { weatherCam } from './weatherCamReducer';
import { weekdayWeekend } from './weekdayWeekendReducer';
import { arity } from './arityReducer';
import { mapFeatures } from './mapFeatureDetailsReducer';
import { coldFluStories } from './coldFluReducer';
import { complianceInfo } from './complianceInfoReducer';
import { map } from './mapReducer';
import { currentConditionsObs } from './currentConditionsReducer';
import { hourlyForecast } from './hourlyForecastReducer';
import { hourlyForecastV5 } from './hourlyForecastReducerV5';
import { hourlyForecastV6 } from './hourlyForecastReducerV6';
import { roadForecast } from './roadForecastReducer';
import { nowConditions } from './nowConditionsReducer';
import { outdoorSports } from './outdoorSportsReducer';
import { selectedStationObservations } from './WeatherStationObservations/SelectedStation/selectedStationObservationsReducer';
import { allStationsObservation } from './WeatherStationObservations/StationsList/allStationsObservationReducer';

export const reducers = {
    adTargetingParameters
    , airQuality
    , alerts
    , allStationsObservation
    , almanac
    , arity
    , averageObs
    , backgroundImage
    , coldFluStories
    , complianceInfo
    , contentManagementTemplate
    , currentConditionsObs
    , currentStationObs
    , feedback
    , fire
    , forecast
    , forecastV5
    , historicalObs
    , hourlyForecast
    , hourlyForecastV5
    , hourlyForecastV6
    , hurricane
    , hurricaneOutlookBulletin
    , hurricaneOutlookSummary
    , icon
    , lightning
    , locationDetails
    , locationSearch
    , map
    , mapFeatures
    , nowConditions
    , nowContent
    , outdoorSports
    , pollen
    , precipitation
    , roadForecast
    , selectedStationObservations
    , storedLocation
    , stories
    , trafficCam
    , userSettings
    , uv
    , video
    , weatherCam
    , weekdayWeekend
};

